import React, { useContext } from 'react';
import Overlay from '@/components/atoms/Overlay';
import RegisterInterest from '@/components/layouts/RegisterInterest';
import { StateContext } from '@/state/store';

import './RegisterInterestOverlay.scss';

const RegisterInterestOverlay = () => {
    const store = useContext(StateContext);
    const { dispatch } = store;
    const { registerInterestOverlayVisible } = store.state;

    const closeRegisterOverlay = () => {
        dispatch({ type: 'HIDE_REGISTER_INTEREST_OVERLAY' });
    };

    return (
        <div className="RegisterInterestOverlay">
            <Overlay open={registerInterestOverlayVisible} onAnimationEndCallback={closeRegisterOverlay}>
                <RegisterInterest ctaCallback={closeRegisterOverlay} />
            </Overlay>
        </div>
    );
};

export default RegisterInterestOverlay;
